module.exports = __webpack_public_path__ + "static/media/chatBox1.235d5d3e.svg";